export function getEmojiLength(emoji) {
    try {
        return [...new Intl.Segmenter().segment(emoji)].length;
    }
    catch (error) {
        return [...emoji].length;
    }
}
